import moment from 'moment'
moment.locale('id')

export function formatDuration(
  durationISO8601,
  late = false,
  format = { days: true, hours: true, minutes: true, seconds: true }
) {
  const duration = moment.duration(durationISO8601)

  const days = duration.days()
  const hours = duration.hours()
  const minutes = duration.minutes()
  const seconds = duration.seconds()

  const formattedDuration = []

  if (days > 0 && format.days) {
    const unit = late ? this.$t('fleetTaskInstant.time.day') : 'd'

    formattedDuration.push(`${days} ${unit}`)
  }

  if (hours > 0 && format.hours) {
    const unit = late ? this.$t('fleetTaskInstant.time.hour') : 'h'

    formattedDuration.push(`${hours} ${unit}`)
  }

  if (minutes > 0 && format.minutes) {
    const unit = late ? this.$t('fleetTaskInstant.time.minute') : 'min'

    formattedDuration.push(`${minutes} ${unit}`)
  }

  if (seconds > 0 && format.seconds) {
    const unit = late ? this.$t('fleetTaskInstant.time.second') : 's'

    formattedDuration.push(`${seconds} ${unit}`)
  }

  if (formattedDuration.length == 0 && !late) {
    formattedDuration.push('- min')
  }

  return formattedDuration.join(' ')
}

export function formatValues(value) {
  return formatDuration(value) || '-'
}

export function formatLateValues(value, withBrackets = true) {
  return (
    `${withBrackets ? '(' : ''}${this.$t('fleetTaskInstant.text.late')} ${formatValues(value, true)}${withBrackets ? ')' : ''}` ||
    ''
  )
}
